import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";

import type { ExchangeCurrencyDetails } from "../../../contract";
import { BETSLIP__EXC_SETTINGS_RECEIVED, type ExchangeSettingsReceivedAction } from "./exchange-settings-actions";

// Layout, not passive, and the two values are taken apart rather than as one object: an object literal
// would be a new reference every render and re-dispatch on each one.
export function useExchangeSettingsSync(discount: number, currencyDetails: ExchangeCurrencyDetails): void {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch<ExchangeSettingsReceivedAction>({
      type: BETSLIP__EXC_SETTINGS_RECEIVED,
      payload: { discount, currencyDetails },
    });
  }, [dispatch, discount, currencyDetails]);
}
